// The body of POST copilot/document/file/{sessionId}/{blockId}/library, and of the KPI data report job save (PLAN-069):
// with listId the user chose the category (and parentFolderId the folder in it); without it the server saves to the
// purpose's default location.
export class SaveCopilotFileToLibraryDTO {
  listId?: number;

  // the drive item id of the folder in the chosen category; the root when absent
  parentFolderId?: string;

  // DocumentOutputPurpose; the default location the server resolves when listId is absent
  purpose?: number;
}

// The answer of a Save to Library of a File block: the new library item.
export class CopilotFileLibrarySaveResultDTO {
  linkId: number;

  listId: number;

  linkName: string;

  // the readable path of the folder the file went to
  folderName?: string;

  // the name the file was saved under
  fileName?: string;

  constructor() {
    this.linkId = 0;
    this.listId = 0;
    this.linkName = '';
  }
}
